// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"YB-z","smallCardRow":"ZB-z","largeCardRow":"_B-z","productSearchRow":"aC-z","curatedRow":"bC-z"};